import React, { useEffect } from "react";
import MediaQuery from "react-responsive";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { closeMenu } from "../../actions/menu";
import styles from "../../styles/Sidebar/Sidebar.module.css";
import { CrossBtnBurger } from "../../styles/View/Infobar/Infobar.styled";

import Menu from "./Menu";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../public/i/eDoc.svg";




export default function Sidebar() {
  const dispatch = useAppDispatch();
  const menu = useAppSelector((state) => state.menu);
  const navigate = useNavigate();
   const account = useAppSelector((state) => state.account);
   const { state, current, total } = useAppSelector((state) => state.upload);
  const handleClose = async () => {
    await dispatch(closeMenu());
  };

  useEffect(() => {
    if (account.state === "success") {
      navigate("/documents");
    }
  }, [account]);

  return (
    <React.Fragment>
      <MediaQuery maxWidth={1239}>
        <div
          className={menu.open ? styles.mobiWrapAside : styles.close}
          onClick={handleClose}
        >
          <aside
            className={`${styles.sidebar} ${styles.mobile} ${
              menu.open ? styles.open : styles.close
            }`}
          >
            <div className={styles.top}>
              <button type="button" onClick={handleClose}>
                <CrossBtnBurger />
              </button>
              <Link to="/">
                <img src={logo} alt="" />
              </Link>
            </div>
            <Menu />
          </aside>
        </div>
      </MediaQuery>

      <MediaQuery minWidth={1240}>
        <aside className={`${styles.sidebar} ${styles.desktop}`} style={{display: "flex", justifyContent: "space-between", flexDirection: "column"}}>
          <Menu />
          {state === "loading" && (
            <div style={{marginBottom: "20px"}} >
            <div style={{  color: "var(--disabled-c)", fontSize: "13px", marginBottom: 4 }}>
              Завантаження {current} з {total} документів
            </div>
              <div style={{ width: '100%', height: 4, backgroundColor: '#eee', borderRadius: 2  }}>
                <div style={{ width: `${(current / total) * 100}%`, height: '100%', backgroundColor: 'var(--blue)', borderRadius: 2  }} />
              </div>
            </div>
          )}
        </aside>
      </MediaQuery>
    </React.Fragment>
  );
}
